import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  useCache,
  usePromiseWrapper,
  useStoreSelector,
  useActions,
} from '../../../helpers/hooks';
import arrowDownBlack from '../../../imgs/arrow_down--black.svg';
import { fetchManual } from '../../../actions/infos';

export default function ManualCard({ id }) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const manual = useStoreSelector(
    (selector) => {
      try {
        const manual = selector.getManual(id);

        return manual[language];
      } catch (e) {}
    },
    [language, id]
  );

  const fetchManualAction = useActions(() => fetchManual(language, id), [
    language,
    id,
  ]);

  const checkManualCache = useCache('manual', id, language);

  const [wrappedManualFetch, manualLoading, manualError] = usePromiseWrapper({
    initPromise() {
      return fetchManualAction();
    },
    cached() {
      return checkManualCache();
    },
  });

  const [open, setOpen] = useState(false);

  // load new manual on language change if open
  useEffect(() => {
    if (open) {
      wrappedManualFetch();
    }
  }, [language]);

  function toggleOpen() {
    const next = !open;

    if (next) {
      wrappedManualFetch();
    }

    setOpen(next);
  }

  return (
    <div className="block instruction">
      <h3
        className={classnames('instruction__btn', { min: !open })}
        onClick={toggleOpen}
      >
        {t('PayWays.Manual')}{' '}
        <img
          src={arrowDownBlack}
          className={classnames('arrow', { 'arrow--flip': open })}
          alt=""
        />
      </h3>
      {!open || manualLoading || manualError ? null : (
        <div
          className="instruction__block"
          dangerouslySetInnerHTML={{ __html: manual }}
        />
      )}
    </div>
  );
}
